import React from 'react'
import { Navbar } from './navbar'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"

export function ReturnBar({ color }){
    function colorSelect(color){
        var classes = "transform ease-in"
        
        if(color === "red"){
            return classes + " hover:text-red-600"
        }
        else if(color === "blue"){
            return classes + " hover:text-blue-600"
        }
        else if(color === "green"){
            return classes + " hover:text-green-600"
        }

        return classes
    }

    return(
        <Navbar>
            <a href='/' className={colorSelect(color)}>
                <FontAwesomeIcon className="text-3xl" icon={faArrowLeft} />
            </a>
        </Navbar>
    );
}